import { render, staticRenderFns } from "./TTPB.vue?vue&type=template&id=1035d640&scoped=true&"
import script from "./TTPB.vue?vue&type=script&lang=js&"
export * from "./TTPB.vue?vue&type=script&lang=js&"
import style0 from "./TTPB.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./TTPB.vue?vue&type=style&index=1&id=1035d640&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1035d640",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VProgressLinear,VRow,VTextField})
